import styled from "styled-components"

export const List = styled.div`
  max-width: 820px;
  border-top: 1px solid var(--line-strong);
  details {
    border-bottom: 1px solid var(--line);
  }
  summary {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 1.5rem;
    padding: 1.1rem 0;
    cursor: pointer;
    list-style: none;
    &::-webkit-details-marker {
      display: none;
    }
    &::after {
      content: "+";
      flex: 0 0 auto;
      display: inline-flex;
      width: 1.4rem;
      height: 1.4rem;
      align-items: center;
      justify-content: center;
      border: 1.5px solid var(--navy);
      border-radius: 2px;
      color: var(--navy);
      font-weight: 600;
      line-height: 1;
    }
  }
  details[open] summary::after {
    content: "−";
  }
  summary h3 {
    margin: 0;
    font-family: var(--font-body);
    font-size: 1.125rem;
    font-weight: 600;
    letter-spacing: 0;
    color: var(--ink);
  }
  details > p {
    margin: 0 0 1.25rem;
    max-width: var(--measure);
  }
`
